const HRD_ACCESS_STATUSES = ["ACTIVE", "READ_ONLY"];

export const getHasHrdAccess = (status: string) =>
  HRD_ACCESS_STATUSES.includes(status);
